// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container_tqAXz","section":"section_vqPXv","banner":"banner_j3Ai+","ui_mask":"ui_mask_SPrhC"};